<template>
  <v-card>
    <v-form @submit.prevent="submitEditBillingPeriod()" ref="editBillingPeriodForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="'Edit Billing Period'" :details="editedBillingPeriod.name"></dialog-header>
          <v-flex xs12 sm8>
            <v-text-field
              label="Name"
              v-model="editedBillingPeriod.name"
              :color="$store.state.global.pages.settings.color"
              :rules="nameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-switch
              label="Open"
              v-model="editedBillingPeriod.isOpen"
              :color="$store.state.global.pages.settings.color"
              :rules="isOpenRules"
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="grey darken-1" @click="close()">Close</v-btn>
        <v-btn flat color="green" :loading="loading" type="submit" v-if="different">Save</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import BillingPeriodService from '@/services/requests/billingPeriodService'
import Store from '@/store/computed/storeHelpers'

// MIXINS
import BillingPeriodValidation from './validation/billingPeriodValidation'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'

export default {
  mixins: [BillingPeriodValidation],
  components: {
    DialogHeader,
  },
  props: {
    billingPeriod: Object,
  },
  data() {
    return {
      loading: false,
      editedBillingPeriod: Object.assign({}, this.billingPeriod),
    }
  },
  computed: {
    different() {
      if (!this._.isEqual(this.billingPeriod, this.editedBillingPeriod)) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.editedBillingPeriod = Object.assign({}, this.billingPeriod)
      this.close()
    },
    submitEditBillingPeriod() {
      if (!this.$refs.editBillingPeriodForm.validate()) {
        return
      }
      const payload = {
        name: this.editedBillingPeriod.name,
        isOpen: this.editedBillingPeriod.isOpen,
        isActive: this.editedBillingPeriod.isActive,
      }
      this.save(payload)
    },
    save(payload) {
      this.loading = true
      BillingPeriodService.updateBillingPeriod(
        this.editedBillingPeriod.id,
        payload
      )
        .then((result) => {
          this.handleSuccess(result)
        })
        .catch((err) => {
          this.handleError(err)
        })
    },
    handleSuccess(result) {
      const billingPeriod = result.data.result
      this.$store.commit('settings/updateArrayStateById', {
        prop: 'billingPeriods',
        value: this.billingPeriod,
        editedValue: billingPeriod,
      })
      this.editedBillingPeriod = Object.assign({}, billingPeriod)
      this.snack({ text: 'Billing period updated', color: 'green' })
      this.close()
      this.loading = false
    },
    handleError(err) {
      this.snack({ text: err.response.data.message, color: 'red' })
      this.loading = false
    },
  },
}
</script>

<style>
</style>